export const TASK_STATUSES = [
  {label: 'Not started', value: 'ASSIGNED', color: '#F4A83B'},
  {label: 'In Progress', value: 'IN_PROGRESS', color: '#6F81DF'},
  {label: 'On Hold', value: 'ON_HOLD', color: '#718490'},
  {label: 'Completed', value: 'COMPLETED', color: '#72B566'},
  {label: 'Canceled', value: 'CANCELED', color: '#B8C1C7'},
];

export const TASK_PRIORITIES = [
  {label: 'High', value: 'HIGH', color: '#E64E7C'},
  {label: 'Medium', value: 'MEDIUM', color: '#718490'},
  {label: 'Low', value: 'LOW', color: '#B8C1C7'},
];

export const TASK_LIST_TITLE_LABEL = 'Task title';
export const TASK_LIST_TITLE_PLACEHOLDER = 'Task title goes here';
export const TASK_LIST_DESCRIPTION_LABEL = 'Task description';
export const TASK_LIST_DESCRIPTION_PLACEHOLDER = 'Task description goes here';
export const TASK_LIST_ASSIGNED_TO_LABEL = 'Assigned to';
export const TASK_LIST_STATUS_LABEL = 'Status';
export const TASK_LIST_PRIORITY_LABEL = 'Priority';
export const TASK_LIST_TARGET_DATE = 'Target date';
export const TASK_LIST_CONFIG_WIDGET_TITLE_PLACEHOLDER = 'Task list';
export const TASK_LIST_CONFIG_PLACEHOLDER_ALL = 'All';
export const TASK_LIST_CONFIG_ASSIGNED_TO_LABEL = 'assigned-to-select';
export const TASK_LIST_CONFIG_PRIORITY_LABEL = 'priority-select';
export const TASK_LIST_CONFIG_STATUS_LABEL = 'status-select';
export const TASK_LIST_CONFIG_CREATOR_LABEL = 'creator-select';
